import moment from 'moment';

export function isSeafreightShipped(line) {
  return (
    line.vpFreightType === 'SeaRailAir' &&
    !!line.actualShippingDate &&
    !moment(line.actualShippingDate, 'YYYY-MM-DD').isSame(moment('0001-01-01', 'YYYY-MM-DD'))
  );
}

export function validateTransferLine(line) {
  const validationErrors = [];
  const validationWarnings = [];
  if (line.qtyToReceive.toString().length > 5) {
    validationErrors.push('Quantity Received cannot have more than 5 digits. Please update.');
  }
  if (
    line.actualReceiptDate === '' ||
    moment(line.actualReceiptDate, 'YYYY-MM-DD').isSame(moment('0001-01-01', 'YYYY-MM-DD'))
  ) {
    validationErrors.push(
      'Please provide a past date for Warehouse Arrival Date. Empty or future dates are not allowed.'
    );
  }
  if (moment(line.actualReceiptDate, 'YYYY-MM-DD').isAfter(moment().format('YYYY-MM-DD'))) {
    validationErrors.push(
      'Please provide a past date for Warehouse Arrival Date. Empty or future dates are not allowed.'
    );
  }
  const remainingQty = line.itemQty - line.qtyShipped;
  const qtyExpected = line.itemQty - line;
  if (line.qtyToReceive > remainingQty) {
    validationErrors.push(
      'The Quantity Received cannot be more than the remaining quantity of ' + remainingQty
    );
  } else if (line.qtyToReceive > qtyExpected) {
    validationErrors.push(
      'The Quantity Received cannot be more than the remaining quantity of ' + qtyExpected
    );
  }
  return {
    ...line,
    validationErrors,
    validationWarnings,
    isValid: validationErrors.length === 0 && validationWarnings.length === 0
  };
}

export function validatePurchaseLine(line, vendorType, orderLines, isFeedBackLoopEnabled) {
  if (line.feedbackStatus === 'Pending') return line;
  if (isSeafreightShipped(line)) return line;
  if (vendorType.toLowerCase() === 'warehouse') {
    return validatePurchaseLineFromWarehouse(line, isFeedBackLoopEnabled);
  } else {
    return validatePurchaseLineFromSupplier(line, orderLines);
  }
}

function validatePurchaseLineFromSupplier(line, orderLines) {
  const validationErrors = [];
  const validationWarnings = [];
  if (
    line.expectedReceiptDate === '' ||
    moment(line.expectedReceiptDate, 'YYYY-MM-DD').isSame(moment('0001-01-01', 'YYYY-MM-DD'))
  ) {
    validationErrors.push(
      'Please provide a future date for Expected GRD Date. Empty or past dates are not allowed.'
    );
  }
  if (line.vndrShpmntNo.length > 20) {
    validationErrors.push('Vendor Shipment No field with not more than 20 Characters.');
  }
  if (line.vendorConfirmQty > line.quantity) {
    validationWarnings.push(
      'Confirmed quantities have exceeded the original quantities! Please contact your Emma Manager to request more quantities.'
    );
  }
  if (line.vpDirectUnitCost === 0 && line.directUnitCost !== 0) {
    validationWarnings.push('Unit price to be confirmed should be greater than 0.');
  }
  if (line.vendorConfirmQty === 0 && line.lossReason === '') {
    validationErrors.push(
      'Vendor Confirm Quantity is zero. Please provide the Root cause for zero confirmation.'
    );
  }
  if (!line.mfgOriginCountry || String(line.mfgOriginCountry).trim() === '') {
    validationErrors.push('Country of Origin is required. Please select a country.');
  }
  return {
    ...line,
    validationErrors,
    validationWarnings,
    isValid: validationErrors.length === 0 && validationWarnings.length === 0
  };
}

function validatePurchaseLineFromWarehouse(line, isFeedBackLoopEnabled) {
  const validationErrors = [];
  const validationWarnings = [];
  if (
    (line.whseConfirmQty && line.whseConfirmQty.toString().length > 5) ||
    (line.seaFreightConfirmedQty && line.seaFreightConfirmedQty.toString().length > 5)
  ) {
    validationErrors.push('Quantity Received cannot have more than 5 digits. Please update.');
  }
  if (
    moment(line.actualReceiptDate, 'YYYY-MM-DD').isSame(moment('0001-01-01', 'YYYY-MM-DD')) ||
    line.actualReceiptDate === ''
  ) {
    validationErrors.push(
      'Please provide a past date for Warehouse Arrival Date. Empty or future dates are not allowed.'
    );
  }
  if (moment(line.actualReceiptDate, 'YYYY-MM-DD').isAfter(moment().format('YYYY-MM-DD'))) {
    validationErrors.push(
      'Please provide a past date for Warehouse Arrival Date. Empty or future dates are not allowed.'
    );
  }
  if (line.vendorConfirmQty > 0) {
    if (line.qtyDmged > line.vendorConfirmQty) {
      validationErrors.push('The Demaged Quantity cannot be more than the Quantity Expected');
    }
  }
  if (line.qtyMissing > line.vendorConfirmQty) {
    validationErrors.push('The Missing Quantity cannot be more than the Quantity Expected');
  }
  if (
    isFeedBackLoopEnabled === true &&
    line.vendorPortalStatusCaption !== 'Confirmation Sent to Vendor' &&
    line.vendorConfirmQty > 0
  ) {
    const limit = line.vendorConfirmQty * 2;
    if (
      (line.whseConfirmQty && line.whseConfirmQty > limit) ||
      (line.seaFreightConfirmedQty && line.seaFreightConfirmedQty > limit)
    ) {
      validationErrors.push(
        'The Warehouse Confirm Quantity cannot be more than the 100% over-receipt'
      );
    }
  }
  return {
    ...line,
    validationErrors,
    validationWarnings,
    isValid: validationErrors.length === 0 && validationWarnings.length === 0
  };
}
